/* @flow */

import * as types from './entityActionTypes';

export function patchEntities(entities: Object) {
  return {
    type: types.PATCH_ENTITIES,
    entities,
  };
}
